// Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Typography, Paper, styled, Snackbar, Alert, useTheme, Grid, Dialog,
  DialogContent,
  IconButton,
  Button,
  useMediaQuery,
} from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CloseIcon from "@mui/icons-material/Close";
import PersonIcon from '@mui/icons-material/Person';
import CastingCard from "../../components/HomeCard";
import useAuth from "app/hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import { GetApprenticeshipById, GetGigWorkById, GetInternshipById, GetJobByID, GetOpportunities, GETReport } from "app/redux/slice/getSlice";
import {
  FollowRequest,
  UnFollowRequest,
  BlockUser,
  GetreportPOST,
  AddBookMark,
  RemoveBookMark,
  PostApply,
} from "app/redux/slice/postSlice";
import Swal from "sweetalert2";
import Loading from "app/components/AppLoading";
import ChatList from "app/components/Chatist";
import JobDetails from "../Account/AppyJob";
import { use } from "react";


const Container = styled("div")(({ theme }) => ({
  margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));

const HomePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  console.log("🚀 ~ HomePage ~ user:", user)
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [blockedUsers, setBlockedUsers] = useState({});
  const [reportDialogData, setReportDialogData] = useState({
    open: false,
    targetUserID: null,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openApplyDialog, setOpenApplyDialog] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

useEffect(() => {
  if (!selectedJob) return; // prevent errors on first render

  if (selectedJob.SourceType === "GW") {
    dispatch(GetGigWorkById({ RecordID: selectedJob.RecordID }));
  } else if (selectedJob.SourceType === "AP") {
    dispatch(GetApprenticeshipById({ RecordID: selectedJob.RecordID }));
  } else if (selectedJob.SourceType === "IN") {
    dispatch(GetInternshipById({ RecordID: selectedJob.RecordID }));
  } else if (selectedJob.SourceType === "JC"){
    dispatch(GetJobByID({ RecordID: selectedJob.RecordID }));
  }
}, [dispatch, selectedJob]);

const gigWorkData = useSelector((state) => state.getSlice.getGigWorkByIdData);
console.log("🚀 ~ HomePage ~ gigWorkData:", gigWorkData);
const internshipData = useSelector((state) => state.getSlice.getInternshipByIdData);
const apprenticeshipData = useSelector((state) => state.getSlice.getApprenticeshipByIdData);
console.log("🚀 ~ HomePage ~ apprenticeshipData:", apprenticeshipData)
 const getJobIDData = useSelector(
    (state) => state.getSlice.getJobIDData
  );
  console.log(getJobIDData, "--getJobIDData");
  console.log("🚀 ~ HomePage ~ getJobIDData:", getJobIDData)
  const handleOpenApply = (job) => {
    setSelectedJob(job);
    setOpenApplyDialog(true);
      console.log("🚀 ~ HomePage ~ selectedJob:", selectedJob)
  };

  const handleCloseApply = (job) => {
    setOpenApplyDialog(false);
    setSelectedJob(null);
  };

  const opportunities = useSelector(
    (state) => state.getSlice.getOpportunitiesData
  );
  console.log("🚀 ~ HomePage ~ opportunities:", opportunities)
  const ProfileCompleted = useSelector(
    (state) => state.getSlice.getOpportunitiesProfile
  );
  const status = useSelector((state) => state.getSlice.getOpportunitiesStatus);
  const error = useSelector((state) => state.getSlice.error);
  const reportOptions = useSelector((state) => state.getSlice.GETReportData);

  // Fetch Opportunities
  useEffect(() => {
    dispatch(GetOpportunities());
  }, [dispatch]);

  // Restore scroll to last card
  useEffect(() => {
    const cardID = sessionStorage.getItem("lastViewedCardID");
    if (cardID) {
      const element = document.getElementById(`casting-card-${cardID}`);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 300); // slight delay for rendering
      }
      sessionStorage.removeItem("lastViewedCardID");
    }
  }, [opportunities]);

  // Follow
  const handleFollowToggle = async (idata) => {
    try {
      const response = await dispatch(FollowRequest(idata));
      setSnackbarMessage(response.payload?.Message);
      setSnackbarSeverity(
        response.payload?.Status === "Y" ? "success" : "error"
      );
      setOpenSnackbar(true);
      return response;
    } catch (err) {
      console.error("Follow Toggle Error:", err);
    }
  };

  // Unfollow
  const handleRemoveFollowToggle = async (idata) => {
    try {
      const response = await dispatch(UnFollowRequest(idata));
      setSnackbarMessage(response.payload?.Message);
      setSnackbarSeverity(
        response.payload?.Status === "Y" ? "success" : "error"
      );
      setOpenSnackbar(true);
      return response;
    } catch (err) {
      console.error("Unfollow Toggle Error:", err);
    }
  };

  // Block
  const handleBlockUser = async (targetUserID) => {
    const response = await dispatch(BlockUser({ "BlockerUserID":user.UserID, BlockedUserID: targetUserID }));
    if (response.payload?.Status === "Y") {   
        Swal.fire("Success", response.payload.Message, "success");
      setBlockedUsers((prev) => ({ ...prev, [targetUserID]: true }));
    }else {
        Swal.fire(
          "Error",
          response.payload.Message || "Something went wrong",
          "error"
        );
      }
  };

  // Report
  const openReportDialog = (userID) => {
    dispatch(GETReport());
    setReportDialogData({ open: true, targetUserID: userID });
  };

  const handleReportSubmit = async (values) => {
    console.log(values, "--oport");
    if (values.cancel) {
      setReportDialogData({ open: false, targetUserID: null });
      return;
    }
    const { selection, reason } = values;
    const idata = {
      ReporterID: user.UserID,
      ReportedID: reportDialogData.targetUserID,
      ReportReasonID: selection,
      Details: reason,
    };
    console.log(idata, "--idata");
    
    // return;
    try {
      const response = await dispatch(GetreportPOST({ idata }));
      if (response.payload?.Status === "Y") {
        Swal.fire("Success", "Reported Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.payload.Message || "Something went wrong",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "Network or server issue", "error");
    } finally {
      setReportDialogData({ open: false, targetUserID: null });
    }
  };

  // Bookmark
  const handleBookmark = async (idata) => {
    try {
      const response = await dispatch(AddBookMark(idata));
      if (response.payload?.Status === "Y") {
        Swal.fire("Success", "Bookmarked Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.payload.Message || "Something went wrong",
          "error"
        );
      }
      return response;
    } catch (err) {
      Swal.fire("Error", "Network or server issue", "error");
      throw err;
    }
  };
const handleApply = async (idata) => {
  console.log("🚀 ~ handleApply ~ idata:", idata);

  try {
    const response = await dispatch(PostApply({idata}));

    // Log the entire response to inspect its structure
    console.log("🚀 ~ handleApply ~ response:", response);

   if (response?.payload?.Status === "Y") {
  Swal.fire("Success", "Reported Successfully", "success").then(() => {
    if (!selectedJob) return; // Prevent crash if null

    const recordID = selectedJob.RecordID;
    const type = selectedJob.SourceType;

    switch (type) {
      case "GW":
        dispatch(GetGigWorkById({ RecordID: recordID }));
        break;

      case "AP":
        dispatch(GetApprenticeshipById({ RecordID: recordID }));
        break;

      case "IN":
        dispatch(GetInternshipById({ RecordID: recordID }));
        break;

      case "JC":
        dispatch(GetJobByID({ RecordID: recordID }));
        break;

      default:
        console.warn("Unknown SourceType:", type);
        break;
    }
  });
}
else {
      Swal.fire(
        "Error",
        response?.payload?.Message || "Something went wrong",
        "error"
      );
    }

    return response;
  } catch (err) {
    Swal.fire("Error", "Network or server issue", "error");
    console.error(err);
    throw err;
  }
};

  const handleRemoveBookmark = async (idata) => {
    try {
      const response = await dispatch(RemoveBookMark(idata));
      if (response.payload?.Status === "Y") {
        Swal.fire("Success", "Bookmark Removed", "success");
      } else {
        Swal.fire(
          "Error",
          response.payload.Message || "Something went wrong",
          "error"
        );
      }
      return response;
    } catch (err) {
      Swal.fire("Error", "Network or server issue", "error");
      throw err;
    }
  };
  const [opportunitiesState, setOpportunitiesState] = useState([]);

  useEffect(() => {
    if (status === "succeeded" && !error) {
      setOpportunitiesState(opportunities); // keep local copy to modify
    }
  }, [status, opportunities]);

  const handleLocalFollowUpdate = (userID, isFollowing) => {
    // setOpportunitiesState((prev) =>
    //   prev.map((item) =>
    //     item.UserID === userID ? { ...item, IsFollowing: isFollowing } : item
    //   )
    // );
  };



  const handleClick = (label) => {
    
      if (label === "Home") {
      navigate("/home");
    }
    if (label === "Create") {
      navigate("/home/create");
    }
    if(label === "Search") {
      navigate("/home/search");
    }
     if(label === "Profile") {
      navigate("/account/my-profile");
    }
  };
console.log("🚀 ~ HomePage ~ selectedJob:", selectedJob)

  return (
    <>
      {status === "succeeded" && !error ? (
      <Container
        maxWidth="xl"
        sx={{
          px: { xs: 1, md: 3 },
          pt: 3,
          pb: 8,
          bgcolor: theme.palette.background.paper,
        }}
      >
   <Grid container spacing={0}>
  {/* Left Column (Cards) */}
  <Grid
    item
    xs={12}
    md={selectedJob ? 4 : 8.5} // ✅ shrink when job selected
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      height: "100%",
      overflowY: "auto",
      transition: "all 0.3s ease",
      pr: 2,
    }}
  >
    {opportunities.map((item) => (
      <Box
        key={item.Id}
        mb={2}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          transition: "all 0.3s ease",
          width: "100%",
        }}
      >
        <CastingCard
          data={item}
           hideImage={!!selectedJob}
          onMediaClick={() => setSelectedJob(item)}
          addFollowing={handleFollowToggle}
          onFollowChange={handleLocalFollowUpdate}
          removeFollowing={handleRemoveFollowToggle}
          isBlocked={!!blockedUsers[item.UserID]}
          onBlock={() => handleBlockUser(item.UserID)}
          onReport={() => openReportDialog(item.UserID)}
          reportDialog={reportDialogData}
          reportOptions={reportOptions}
          onReportSubmit={handleReportSubmit}
          onAddBookmark={handleBookmark}
          onRemoveBookmark={handleRemoveBookmark}
          onCardClick={() => {
            console.log("----onclicking the CastingCard");
            
            sessionStorage.setItem("lastViewedCardID", item.Id);
            navigate(`/casting/${item.Id}`);
          }}
        />
      </Box>
    ))}
  </Grid>

  {/* Right Column — Job Details + Chat */}
  <Grid
    item
    xs={12}
    md={selectedJob ? 8 : 3.5} // ✅ expand when job selected
    sx={{
      display: "flex",
      flexDirection: "column",
      position: "sticky",
      top: 0,
      height: "calc(100vh - 100px)",
      overflowY: "auto",
      transition: "all 0.3s ease",
    }}
  >
    {/* ✅ JobDetails occupies 3/4 of total page width when open */}
    {selectedJob && (
      <Box
        sx={{
          flex: 1,
          width: "100%",
          transition: "all 0.3s ease",
          mb: 2,
        }}
      >
        <JobDetails job={selectedJob}
        gigWorkData={gigWorkData}
  internshipData={internshipData}
  apprenticeshipData={apprenticeshipData} 
  JobData={getJobIDData}
  OnClose={() => setSelectedJob(null)} OnApply={handleApply}/>
      </Box>
    )}

    {/* ✅ Chat list remains below */}
      {!selectedJob && (
    <ChatList enableNavigation />
)}
  </Grid>
<Box
  // sx={{
  //   position: "sticky",
  //   bottom: 90,
  //   width: "100%",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   zIndex: 1000,
  // }}
  sx={{
        position: "fixed",
        bottom: 16,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 1300,
      }}
>
  <Box
    // sx={{
    //   display: "flex",
    //   //  position: "sticky",
    //   gap: 1,
    //   bgcolor: "#333", // dark taskbar background
    //   p: 0.8,
    //   borderRadius: "8px",
    //   boxShadow: "0px 2px 6px rgba(0,0,0,0.3)",
    // }}
     sx={{
          display: "flex",
          gap: isMobile ? 0.5 : 1,
          bgcolor: "#333",
          p: 0.8,
          borderRadius: "14px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.35)",
        }}
  >
    {["Home","Create", "Search", "Profile" ].map((label, index) => (
      <Button
         onClick={() => handleClick(label)}
        key={index}
        variant="outlined"
        // sx={{
        //   color: "#fff",
        //   borderColor: "#555",
        //   textTransform: "none",
        //   fontSize: "14px",
        //   fontWeight: 500,
        //   px: 2,
        //   py: 0.6,
        //   borderRadius: "6px",
        //   "&:hover": {
        //     backgroundColor: "#444",
        //     borderColor: "#777",
        //   },
        // }}
        sx={{
    minWidth: isMobile ? 48 : "auto",
    px: isMobile ? 1 : 2,
    py: 1,
    color: "#fff",
    borderRadius: "10px",   // ✅ comma added
    borderColor: "#555",
    bordeWidth: "2px",
    textTransform: "none",
    fontSize: 13,
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 0.5,
    "&:hover": {
      bgcolor: "#444",
      
    },
  }}
      >
        {/* <HomeIcon /> */}
      {label === "Menu" ? (
  <>
    <span style={{ marginRight: 4 }}>☰</span>
    {label}
  </>
) : label === "Home" ? (
  <>
    <span style={{ marginRight: 4 }}><HomeOutlinedIcon  /></span>
    {label}
  </>
  ) : label === "Create" ? (
  <>
    <span style={{ marginRight: 4 }}><AddCircleOutlineOutlinedIcon  /></span>
    {label}
  </>
  
   ) : label === "Search" ? (
  <>
    <span style={{ marginRight: 4 }}><SearchOutlinedIcon  /></span>
    {label}
  </>
    ) : label === "Profile" ? (
  <>
    <span style={{ marginRight: 4 }}><PersonIcon  /></span>
    {label}
  </>
) : (
  label
)}
      </Button>
    ))}
  </Box>
</Box>

</Grid>




        {/* Snackbar */}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar> 
        
       <Dialog
  open={openApplyDialog}
  onClose={handleCloseApply}
  maxWidth="md"
  fullWidth
>
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      p: 2,
      borderBottom: "1px solid",
      borderColor: "divider",
    }}
  >
    <Box sx={{ fontWeight: 600, fontSize: "1.1rem" }}>
      Apply for {selectedJob?.Title || "Job"}
    </Box>
    <IconButton onClick={handleCloseApply}>
      <CloseIcon />
    </IconButton>
  </Box>

  <DialogContent sx={{ p: 3 }}>
    {/* ✅ Only render JobDetails if data is ready */}
    {selectedJob ? (
      <JobDetails job={selectedJob} />
    ) : (
      <Typography>Loading job details...</Typography>
    )}
  </DialogContent>
</Dialog>


      </Container>

      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <Loading />
        </Box>
      )}
    </>
  );
};

export default HomePage;
{/* Profile Completion Card */ }

{/* {ProfileCompleted !== 4 && (
            <Paper
              elevation={3}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 2,
                mx: 2,
                mt: 2,
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  bgcolor: "#e0f0ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <Box textAlign="center">
                  <Typography variant="caption" color="textSecondary">
                    status
                  </Typography>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {`${ProfileCompleted}/4`}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography
                  onClick={() => navigate("/setting/edit-profile")}
                  variant="subtitle1"
                  sx={{
                    color: "#4f55e1",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Complete your profile
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={0.5}>
                  Completing your profile will help you get better
                  opportunities and give more visibility.
                </Typography>
              </Box>
            </Paper>
          )} */}
{/* Opportunity Cards */ }
// const opportunities = [
//   {
//     "Id": 1,
//     "RecordID": 57,
//     "UserID": 391,
//     "UserName": "Manoj",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_141016.jpeg",
//     "Designation": "Editor",
//     "WorkTypeName": "Full-time",
//     "ShortDesc": "",
//     "Title": "Actor",
//     "ProjectID": 0,
//     "GigWorkType": "",
//     "ProjectName": "",
//     "WorkingHours": "",
//     "Price": "",
//     "PriceType": "",
//     "Gender": "",
//     "Duration": "10 Month",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "Need to support for fight scene",
//     "Location": "Chennai",
//     "StartDate": "2025-01-01",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Apprenticeship\/20250813_143241.jpeg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 14:32:41",
//     "CreatedHours": "7 days ago",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Apprenticeship",
//     "SourceType": "AP"
//   },
//   {
//     "Id": 2,
//     "RecordID": 56,
//     "UserID": 391,
//     "UserName": "Manoj",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_141016.jpeg",
//     "Designation": "Vedio editor",
//     "WorkTypeName": "Full-time",
//     "ShortDesc": "",
//     "Title": "Editor",
//     "ProjectID": 0,
//     "GigWorkType": "",
//     "ProjectName": "",
//     "WorkingHours": "",
//     "Price": "",
//     "PriceType": "",
//     "Gender": "",
//     "Duration": "10 Month",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "Need to support for editor clips",
//     "Location": "Chennai",
//     "StartDate": "2025-01-01",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Apprenticeship\/default_cover.jpg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 14:22:34",
//     "CreatedHours": "7 days ago",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Apprenticeship",
//     "SourceType": "AP"
//   },
//   {
//     "Id": 3,
//     "RecordID": 130,
//     "UserID": 391,
//     "UserName": "Manoj",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_141016.jpeg",
//     "Designation": "Content writer",
//     "WorkTypeName": "Full-time",
//     "Title": "Actor",
//     "ProjectID": 0,
//     "GigWorkType": "",
//     "ProjectName": "",
//     "WorkingHours": "",
//     "ShortDesc": "",
//     "Price": "",
//     "PriceType": "",
//     "Gender": "",
//     "Duration": "10 Month",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "Take a Short film",
//     "Location": "Chennai",
//     "StartDate": "2025-01-01",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Internship\/20250813_141859.jpeg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 14:18:59",
//     "CreatedHours": "7 days ago",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Internship",
//     "SourceType": "IN"
//   },
//   {
//     "Id": 4,
//     "RecordID": 96,
//     "UserID": 390,
//     "ProjectID": 96,
//     "ProjectName": "Film",
//     "UserName": "Akash",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_093336.jpeg",
//     "Designation": "",
//     "ShortDesc": "Action movie inbetween labour and Manager",
//     "Title": "Coolie",
//     "Price": "1000",
//     "PriceType": "Fixed",
//     "WorkingHours": "8",
//     "GigWorkType": "Individual",
//     "WorkTypeName": "Remote",
//     "Gender": "",
//     "Duration": "",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "",
//     "Location": "Chennai",
//     "StartDate": "",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/GigWork\/20250813_105455.jpeg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 10:54:55",
//     "CreatedHours": "August 13, 2025",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Gigs",
//     "SourceType": "GW"
//   },
//   {
//     "Id": 5,
//     "RecordID": 55,
//     "UserID": 390,
//     "UserName": "Akash",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_093336.jpeg",
//     "Designation": "Vedio editor",
//     "WorkTypeName": "Part-time",
//     "ShortDesc": "",
//     "Title": "Editor",
//     "ProjectID": 0,
//     "GigWorkType": "",
//     "ProjectName": "",
//     "WorkingHours": "",
//     "Price": "",
//     "PriceType": "",
//     "Gender": "",
//     "Duration": "10 Month",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "Editing the client short film",
//     "Location": "Chennai",
//     "StartDate": "2025-01-01",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Apprenticeship\/20250813_104758.jpeg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 10:47:58",
//     "CreatedHours": "August 13, 2025",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Apprenticeship",
//     "SourceType": "AP"
//   },
//   {
//     "Id": 6,
//     "RecordID": 129,
//     "UserID": 390,
//     "UserName": "Akash",
//     "ProfileImage": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Profile\/Profile\/20250813_093336.jpeg",
//     "Designation": "Content writer",
//     "WorkTypeName": "Part-time",
//     "Title": "Content writer",
//     "ProjectID": 0,
//     "GigWorkType": "",
//     "ProjectName": "",
//     "WorkingHours": "",
//     "ShortDesc": "",
//     "Price": "",
//     "PriceType": "",
//     "Gender": "",
//     "Duration": "10 Month",
//     "Age": "",
//     "Height": "",
//     "BodType": "",
//     "Responsibility": "Create a new content for a website",
//     "Location": "Chennai",
//     "StartDate": "2024-01-01",
//     "EndDate": "",
//     "StartTime": "",
//     "EndTime": "",
//     "Image": "https:\/\/uatapi.creanetwork.in\/public\/uploads\/Internship\/20250813_104553.jpeg",
//     "IsDraft": 0,
//     "Created": "August 13, 2025",
//     "CreatedTime": "2025-08-13 10:45:53",
//     "CreatedHours": "August 13, 2025",
//     "IsBookmarked": false,
//     "IsFollowing": false,
//     "Source": "Internship",
//     "SourceType": "IN"
//   }
// ];

{/* <Container>
        <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 8,
          bgColor:theme.palette.background.paper
         }}>
         
          <Box sx={{ textAlign: "center", color: "text.secondary", mt: 6 }}>
            {opportunities.map((item) => (
              <Box key={item.Id} id={`casting-card-${item.Id}`} mb={2}>
                <CastingCard
                  data={item}
                  addFollowing={handleFollowToggle}
                  onFollowChange={handleLocalFollowUpdate}
                  removeFollowing={handleRemoveFollowToggle}
                  isBlocked={!!blockedUsers[item.UserID]}
                  onBlock={() => handleBlockUser(item.UserID)}
                  onReport={() => openReportDialog(item.UserID)}
                  reportDialog={reportDialogData}
                  reportOptions={reportOptions}
                  onReportSubmit={handleReportSubmit}
                  onAddBookmark={handleBookmark}
                  onRemoveBookmark={handleRemoveBookmark}
                  onCardClick={() => {
                    sessionStorage.setItem("lastViewedCardID", item.Id);
                    navigate(`/casting/${item.Id}`);
                  }}
                />
              </Box>
            ))}
          </Box>
          <ChatList/>
        </Box>

      
        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container> */}
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   BottomNavigation,
//   BottomNavigationAction,
//   IconButton,
//   Typography,
//   Avatar,
//   Paper,
//   Tabs,
//   Tab,
//   Fab,
//   styled
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import HomeIcon from "@mui/icons-material/Home";
// import SearchIcon from "@mui/icons-material/Search";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
// const Container = styled("div")(({ theme }) => ({
//   margin: "30px",
//   [theme.breakpoints.down("sm")]: { margin: "16px" },
//   "& .breadcrumb": {
//     marginBottom: "30px",
//     [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
//   },
// }));
// const HomePage = () => {
//   const navigate = useNavigate();

//   const handleSearchClick = () => {
//     navigate("/search");
//   };

//   return (
//     <Container>


//       {/* Profile Card */}
//       <Paper elevation={3} sx={{ display: "flex", alignItems: "center", p: 2, mx: 2, mt: 2, borderRadius: 2 }}>
//         <Box
//           sx={{
//             width: 60,
//             height: 60,
//             borderRadius: "50%",
//             bgcolor: "#e0f0ff",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             mr: 2,
//           }}
//         >
//           <Box textAlign="center">
//             <Typography variant="caption" color="textSecondary">status</Typography>
//             <Typography variant="subtitle2" fontWeight="bold">0 of 4</Typography>
//           </Box>
//         </Box>
//         <Box>
//           <Typography variant="subtitle1" sx={{ color: "#4f55e1", fontWeight: "bold" }}>
//             Complete your profile
//           </Typography>
//           <Typography variant="body2" color="text.secondary" mt={0.5}>
//             Completing your profile will help you get better opportunities and give more visibility.
//           </Typography>
//         </Box>
//       </Paper>

//       {/* Empty Data */}
//       <Box sx={{ textAlign: "center", color: "text.secondary", mt: 6 }}>
//         No data found
//       </Box>

//       {/* Bottom Navigation */}

//     </Container>
//   );
// };

// export default HomePage;












